import React, { useState } from "react";

const Card_Leadership = ({ cardData }) => {
  const [viewMoreStates, setViewMoreStates] = useState(
    Array(cardData.cards.length).fill(false)
  );

  const toggleViewMore = (index) => {
    setViewMoreStates((prevStates) =>
      prevStates.map((state, i) => (i === index ? !state : state))
    );
  };

  return (
    <div className="w-full flex justify-center mt-5 px-4">
      <div className="w-full flex flex-col gap-10 sm:w-full md:w-full lg:w-4/5 xl:w-full">
        {/* Card Title */}
        <h2 className="flex justify-center items-center text-center text-[24px] font-bold">
          {cardData.title}
        </h2>
        <div className="w-full flex flex-wrap justify-center items-center gap-6">
          {cardData.cards.map((data, index) => (
            <div
              key={index}
              className="flex flex-col justify-center items-center
               w-[90%] sm:w-[80%] md:w-[45%] lg:w-[30%] xl:w-[25%] p-4 border rounded-lg shadow-md
               transform transition-transform duration-300 hover:scale-105 hover:shadow-lg"
            >
              {/* Logo */}
              <div className="flex flex-col items-center justify-center">
                <img
                  src={data.image}
                  alt={data.alt}
                  className="h-[150px] w-[150px] rounded-full bg-gray-500 "
               
                />
              </div>
              {/* Title */}
              <div className="text-center">
                <h3 className="text-[18px] mt-3 font-bold">{data.name}</h3>
                <p>{data.position}</p>
              </div>
              {/* Content */}
              <div
                className={`overflow-y-auto ${
                  viewMoreStates[index]
                    ? "h-[80px] overflow-y-auto"
                    : "h-[80px] overflow-hidden"
                } no-scrollbar text-center`}
              >
                <p className="text-[14px] text-[#6d6e70]">{data.message}</p>
              </div>
              {/* Button */}
              <button
                className="text-[#969ca6]"
                onClick={() => toggleViewMore(index)}
              >
                {viewMoreStates[index] ? "View Less" : "View More"}
              </button>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Card_Leadership;
